export const checkIfFundIsActive = (fund) => {
  if (!fund) {
    return false;
  }

  return fund.isActive === "1" && fund.isEnabled === "1";
}

export const checkIfFundIsCeased = (fund) => {
  if (!fund) {
    return true;
  }

  return fund.isActive === "1" && (fund.isEnabled === "0" || fund.isEnabled === "1");
}

export const checkIfFundIsTerminated = (fund) => {
  if (!fund) {
    return true;
  }

  return fund.isActive === "0" && fund.isEnabled === "0";
}